import React, { Component } from "react";
import Axios from "axios";
import moment from "moment";

class TheWeather extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    theWeathers: undefined,
  };

  async componentDidMount() {
    setTimeout(() => {
      this.loadtheWeathersAxios();
    }, 100);
  }

  loadtheWeathers(el) {
    const elSliced = el.slice(0, 2);

    const theTrimmedWeather = elSliced.map((node) => {
      return {
        detailed: node.detailedForecast,
        isDaytime: node.isDaytime,
        name: node.name,
        shortForecast: node.shortForecast,
        temperature: node.temperature,
      };
    });

    /////////////////////////////////////////////////////////////////////

    if (this.state.theWeathers) return;

    if (typeof theTrimmedWeather != "object") return;

    this.setState({ theWeathers: theTrimmedWeather });
  }

  // "https://api.weather.gov/gridpoints/OKX/33,36/forecast";
  // api.weather.gov/points/40.7484,-73.9856
  loadtheWeathersAxios() {
    Axios.request({
      method: "GET",
      url: "//api.weather.gov/gridpoints/OKX/33,36/forecast",
    })
      .then((response) => {
        if (!response.data) return;

        const thePeriods = response.data.properties.periods;
        if (!thePeriods) return;

        this.loadtheWeathers(thePeriods);
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  render() {
    const theWeathers = this.state.theWeathers;
    if (!theWeathers) return;

    return (
      <div id="the-weather" className="the-weather">
        <div className="top">
          <h4>Forecast at Levi's Stadium</h4>
        </div>
        <div className="the-body">
          {theWeathers.map((node, i) => {
            return (
              <div className={`chunk-weather`} key={i}>
                <div className="left">
                  <div className="temp">
                    {node.temperature} <span>℉</span>
                  </div>
                  <div className="the-icon">
                    <img
                      src={`/icons/${
                        node.isDaytime ? "day-white.png" : "night-white.png"
                      }`}
                    />
                  </div>
                </div>
                <div className="right">
                  <div className="name"> {node.name} </div>
                  <div className="details"> {node.detailed} </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default TheWeather;
